import TenantComponents from '@components';
export const PlatformListingActions = (props) => {
  return <TenantComponents.PlatformActions {...props} />;
};
